import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VContainer, {
    staticClass: "pa-0 ma-0",
    attrs: {
      "fluid": ""
    }
  }, [_vm.item.health ? _c('div', [_vm.item.health.state === 0 ? _c('div', {
    staticClass: "status status-color-ok"
  }, [_vm._v("\n      " + _vm._s(_vm.healthStatus[0]) + "\n    ")]) : _vm.item.health.state === 3 ? _c('div', {
    staticClass: "status"
  }, [_vm._v("\n      " + _vm._s(_vm.healthStatus[3]) + "\n    ")]) : _vm.invalidHealthState ? _c('div', {
    staticClass: "status"
  }, [_vm._v("\n      " + _vm._s(_vm.healthStatus[4]) + "\n    ")]) : _vm._e(), _vm._l(_vm.computedErrors, function (error, errorIndex) {
    return _c('div', {
      key: `error_${errorIndex}`,
      class: `status ${!error._isIgnored ? 'status-color-error' : ''}`
    }, [_vm._v("\n      " + _vm._s(_vm.healthStatus[2]) + "\n      "), _c(VIcon, {
      staticClass: "ml-2",
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "title": _vm.$i18n_t(`DigitalTwin.VirtualDevice.state.health.${!error._isIgnored ? 'ignore' : 'unignore'}`),
        "color": "#808080",
        "small": ""
      },
      on: {
        "click": function ($event) {
          return _vm.ignoreHealthMessage(_vm.item || {}, error.id);
        }
      }
    }, [_vm._v("\n        " + _vm._s(!error._isIgnored ? 'fal fa-toggle-off' : 'fal fa-toggle-on') + "\n      ")]), _c('br'), _c('div', {
      staticClass: "minitext truncate",
      staticStyle: {
        "min-width": "150px"
      },
      attrs: {
        "title": error.message
      }
    }, [_vm._v("\n        " + _vm._s(error.message) + "\n      ")])], 1);
  }), _vm._l(_vm.computedWarnings, function (warning, warningIndex) {
    return _c('div', {
      key: `warning_${warningIndex}`,
      class: `status ${!warning._isIgnored ? 'status-color-warning' : ''}`
    }, [_vm._v("\n      " + _vm._s(_vm.healthStatus[1]) + "\n      "), _c(VIcon, {
      staticClass: "ml-2",
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "title": _vm.$i18n_t(`DigitalTwin.VirtualDevice.state.health.${!warning._isIgnored ? 'ignore' : 'unignore'}`),
        "color": "#808080",
        "small": ""
      },
      on: {
        "click": function ($event) {
          return _vm.ignoreHealthMessage(_vm.item || {}, warning.id);
        }
      }
    }, [_vm._v("\n        " + _vm._s(!warning._isIgnored ? 'fal fa-toggle-off' : 'fal fa-toggle-on') + "\n      ")]), _c('br'), _c('span', {
      staticClass: "minitext truncate",
      staticStyle: {
        "min-width": "150px"
      },
      attrs: {
        "title": warning.message
      }
    }, [_vm._v("\n        " + _vm._s(warning.message) + "\n      ")])], 1);
  })], 2) : _c('div', [_c('div', {
    staticClass: "status"
  }, [_vm._v("\n      " + _vm._s(_vm.healthStatus[4]) + "\n    ")])])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };